export default __webpack_public_path__ + "f4416c7021b51102f0408cdc6e844a3f.png";